import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { BENEFITS } from "@/data/site";
import { SectionHead } from "@/components/site/Reveal";

export const Benefits = () => (
  <section id="services" className="relative py-24 md:py-36" data-testid="benefits-section">
    <div className="glow-orb w-[460px] h-[460px] bg-cyan-500/8 bottom-0 -left-52" />
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHead
        label="Ce que vous y gagnez"
        title={
          <>
            Un site avec nous, <span className="text-gradient">c'est concret.</span>
          </>
        }
        subtitle="Un site internet professionnel n'est pas une dépense : c'est un outil qui travaille pour votre activité, tous les jours."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {BENEFITS.map((b, i) => {
          const Icon = Icons[b.icon] || Icons.Star;
          return (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`card-surface rounded-2xl p-7 md:p-8 ${i === 6 ? "sm:col-span-2 lg:col-span-1" : ""}`}
              data-testid={`benefit-card-${i}`}
            >
              <span className="inline-flex w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500/20 to-violet-500/20 border border-white/[0.09] items-center justify-center mb-5">
                <Icon size={19} className="text-[var(--accent-cyan)]" />
              </span>
              <h3 className="font-display font-bold text-lg md:text-xl tracking-tight">{b.title}</h3>
              <p className="text-[var(--text-secondary)] text-sm md:text-base mt-2.5 leading-relaxed">{b.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Benefits;
